import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout.tsx";
import Book from "./pages/Book.tsx";
import Catalogue from "./pages/Catalogue.tsx";
import Help from "./pages/Help.tsx";
import Home from "./pages/Home.tsx";
import LogicGrids from "./pages/LogicGrids.tsx";
import NotFound from "./pages/NotFound.tsx";
import Solve from "./pages/Solve.tsx";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="catalogue" element={<Catalogue />} />
        <Route path="catalogue/:slug" element={<Book />} />
        {/* A line owns its guarantees. The press's front page cannot promise
            "exactly one solution" on behalf of a book type that does not exist
            yet, so anything that narrow lives on the line's own page. */}
        <Route path="logic-grids" element={<LogicGrids />} />
        {/*
          Help is its own page, and each book has its own address under it. The
          code printed in a book points at `/help/<slug>`, which knows which
          book the reader is holding and only has to ask which puzzle; `/help`
          bare is for somebody who arrives without one.

          Both paths are printed into books, so neither may move. Everything on
          the page around them can be rearranged freely.
        */}
        <Route path="help" element={<Help />} />
        <Route path="help/:slug" element={<Help />} />
        {/*
          A workbench for solving unpublished books on screen, reading the
          working copies `bun run export:drafts` writes. Dev only, and
          deliberately: those books are not on sale and their files carry the
          solutions, so this must not exist in a build that gets deployed.
        */}
        {import.meta.env.DEV && <Route path="solve" element={<Solve />} />}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
